import React from "react";
import { Doughnut } from "react-chartjs-2";
import ASSET_CLASSES from "../../asset-classes";
import Skeleton from "react-loading-skeleton";

/**
 * Display different portfolios compositions
 * according the allocation in Pandhora funds and the 
 * client's allocation in other asset classes.
 *
 * @author Giovanna Marinelli
 */
const PortfolioComposition = ({ portfolio, portfolioExPandhora }) => {
  /**
   * Create the legend of the chart indicating
   * which color corresponts to which asset class.
   *
   * @param {string} name The name of the class
   * @param {string} span The alternative (nick) name of the class
   * @param {string} color The color of the class displayed on chart
   */
  const createLegend = (name, span, color) => {
    return (
      <div key={name} className="PortfolioComposition__legend">
        <span
          className={`PortfolioComposition__dot PortfolioComposition__dot--${color}`}
        ></span>
        {`${name} `}
        {span ? (
          <span style={{ fontSize: "0.7rem" }}>{`(${span})`}</span>
        ) : undefined}
      </div>
    );
  };

  /**
   * Plot a chart with an allocation between the different asset classes
   * and Pandhora's funds.
   */
  const plotChart = (targetPositions, title) => {
    const labels = Object.keys(ASSET_CLASSES).map((k) => ASSET_CLASSES[k].name);
    const colors = Object.keys(ASSET_CLASSES).map(
      (k) => ASSET_CLASSES[k].color
    );
    return (
      <div>
      <div className="PortfolioComposition__chart-title">{title}</div>
        <Doughnut
          width={300}
          height={200}
          options={{
            responsive: true,
            cutoutPercentage: 0,
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: function(tooltipItem, data) {
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  var labels = data.labels;
                  var percentage = dataset.data[tooltipItem.index];
                  var label = labels[tooltipItem.index];
                  return " "+ label +": " + percentage + "%";
                }
              }
            } 
          }
        }
          data={{
            datasets: [
              {
                data: Object.keys(targetPositions).map(
                  (assetClass) => (targetPositions[assetClass]*100.0).toFixed(2)
                ),
                backgroundColor: colors,
              },
            ],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: labels,
            backgroundColor: colors,
          }}
        />
      </div>
    );
  };

  return (
    <div className="PortfolioComposition__container container">
      <div className="row">
        <div className="col-xl-4">
          <div className="PortfolioComposition__title">
            Composição da carteira
          </div>
          {portfolio ? (
            Object.keys(ASSET_CLASSES).map((key) => {
              const assetClass = ASSET_CLASSES[key];
              return createLegend(
                assetClass.name,
                assetClass.altName,
                assetClass.colorName
              );
            })
          ) : (
            <Skeleton count={10} />
          )}
        </div>
        <div
          className="col-xl-8"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="PortfolioComposition__chart-container row">
            <div className="col-6">
              {portfolio ? (
                plotChart(portfolio.targetPositions, 'Carteira com a Pandhora')
              ) : (
                <Skeleton width="200px" height="200px" />
              )}
            </div>
            <div className="col-6">
              {portfolio ? (
                plotChart(portfolioExPandhora.targetPositions, 'Sua carteira atual')
              ) : (
                <Skeleton width="200px" height="200px" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioComposition;
